import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthAPI } from 'src/app/providers/authentication.api.service';
import { EventsAPI } from 'src/app/providers/events.api.service';

@Component({
  selector: 'app-host-create-admins',
  templateUrl: './host-create-admins.component.html',
  styleUrls: ['./host-create-admins.component.scss'],
})
export class HostCreateAdminsComponent implements OnInit {
  eventId: string;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authAPI: AuthAPI,
    private eventService: EventsAPI
  ) {}

  async ngOnInit() {
    const token = await this.authAPI.getAnonToken();
    this.route.params.subscribe(async (params) => {
      this.eventId = params['eventId'];
      const eventResponse = await this.eventService.getEvent(this.eventId, token).toPromise();
      const loadedEvent = (eventResponse as any).event;
    });
  }

  gotoCreatePreview() {
    this.router.navigate([`/host/${this.eventId}`]);
  }
}
